export default {
  meta: {
    public: false,
    auth: true,
    icon: "fa-file-archive-o",
    expanded: false,
    label: "Reports",
    permission: [config.permission.REPORTS_INDEX]
  },
  children: [
    // {
    //   path: "/report/subscription",
    //   meta: {
    //     label: "Subscription",
    //     breadcrumb: [{ name: "Subscription" }],
    //     permission: [config.permission.REPORTS_INDEX]
    //   },
    //   component: () => import("views/report/subscription")
    // },
    {
      name: "daily_order",
      path: "/report/daily_order",
      meta: {
        label: "Daily Order",
        breadcrumb: [{ name: "Daily Order" }],
        permission: [config.permission.REPORTS_INDEX]
      },
      component: () => import("views/report/daily_order")
    },
    {
      name: "daily_stock",
      path: "/report/daily_stock",
      meta: {
        label: "Daily Stock",
        breadcrumb: [{ name: "Daily Stock" }],
        permission: [config.permission.REPORTS_INDEX]
      },
      component: () => import("views/report/daily_stock")
    },
    {
      name: "stock_report",
      path: "/report/stock_report",
      meta: {
        label: "Stock Checking",
        breadcrumb: [{ name: "Stock Checking" }],
        permission: [config.permission.REPORTS_INDEX]
      },
      component: () => import("views/report/stock_report")
    }
  ]
};
